var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M21.089 11.155a9.466 9.466 0 0 1-18.932 0c0-5.228 4.238-9.519 9.466-9.519s9.466 4.291 9.466 9.519"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M18.847 17.272 22 24.42l-4.067-1.38-1.7 3.943-2.875-6.521M9.888 20.462l-2.875 6.521-1.7-3.943-4.067 1.38L4.4 17.272M11.623 6.422l1.391 2.818 3.11.452-2.25 2.194.531 3.098-2.782-1.463-2.782 1.463.532-3.098-2.25-2.194 3.11-.452z"
  })));
};
export default SvgStar;